import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { ToastContainer, toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import emailjs from 'emailjs-com';
import 'react-toastify/dist/ReactToastify.css';

const Contact = () => {
    const { t } = useTranslation();

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors }
    } = useForm();
    const [disabled, setDisabled] = useState(false);

    const toastifySuccess = () => {
        toast(t('contact.success'), {
            position: 'bottom-right',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            className: 'submit-feedback success',
            toastId: 'notifyToast'
        });
    };

    const onSubmit = async (data) => {
        const { firstName, lastName, email, message } = data;
        try {
            setDisabled(true);

            const templateParams = {
                firstName,
                lastName,
                email,
                message,
                toEmail: 'admin@blank-text.net',
            };

            await emailjs.send(
                process.env.REACT_APP_SERVICE_ID,
                process.env.REACT_APP_TEMPLATE_ID,
                templateParams
            );

            reset();
            toastifySuccess();
            setDisabled(false);
        } catch (e) {
            console.error('Error sending email:', e);
            setDisabled(false);
        }
    };

    return (
        <div className="page-content container">
            <div className='ContactForm'>
                <div className='container'>
                    <div className='row'>
                        <h1><b>{t('contact.title')}</b></h1>
                        <div className='col-12 text-center'>
                            <div className='contactForm'>
                                <form id='contact-form' onSubmit={handleSubmit(onSubmit)} noValidate>
                                    <div className='row formRow'>
                                        <div className='col-6'>
                                            <input
                                                type='text'
                                                {...register('firstName', {
                                                    required: t('contact.firstNameRequired'),
                                                    maxLength: {
                                                        value: 30,
                                                        message: t('contact.firstNameMax')
                                                    }
                                                })}
                                                className='form-control formInput'
                                                placeholder={t('contact.firstName')}
                                            />
                                            {errors.firstName && <span className='errorMessage'>{errors.firstName.message}</span>}
                                        </div>
                                        <div className='col-6'>
                                            <input
                                                type='text'
                                                {...register('lastName', {
                                                    required: t('contact.lastNameRequired'),
                                                    maxLength: {
                                                        value: 30,
                                                        message: t('contact.lastNameMax')
                                                    }
                                                })}
                                                className='form-control formInput'
                                                placeholder={t('contact.lastName')}
                                            />
                                            {errors.lastName && <span className='errorMessage'>{errors.lastName.message}</span>}
                                        </div>
                                    </div>

                                    <div className='row formRow'>
                                        <div className='col'>
                                            <input
                                                type='email'
                                                {...register('email', {
                                                    required: t('contact.emailRequired'),
                                                    pattern: {
                                                        value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                                                        message: t('contact.emailValid')
                                                    }
                                                })}
                                                className='form-control formInput'
                                                placeholder={t('contact.email')}
                                            />
                                            {errors.email && <span className='errorMessage'>{errors.email.message}</span>}
                                        </div>
                                    </div>

                                    <div className='row formRow'>
                                        <div className='col'>
                                            <textarea
                                                rows={4}
                                                {...register('message', {
                                                    required: t('contact.messageRequired')
                                                })}
                                                className='form-control formInput'
                                                placeholder={t('contact.message')}
                                            ></textarea>
                                            {errors.message && <span className='errorMessage'>{errors.message.message}</span>}
                                        </div>
                                    </div>

                                    <button className='submit-btn button' disabled={disabled} type='submit'>
                                        {t('contact.submit')}
                                    </button>
                                </form>
                            </div>
                            <ToastContainer />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;
